import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lfsa-loading',
  templateUrl: './lfsa-loading.component.html',
  styleUrls: ['./lfsa-loading.component.css']
})
export class LfsaLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
